import { IEvent } from "@Interfaces";
import { ACTION_TYPES, createAction } from "@Utils";
import { useDispatch } from "react-redux";

export const useSetNumberOfCustomers = () => {
    const dispatch = useDispatch();
    const setNumberOfCustomers = (
        numberOfCustomers: IEvent.IPaymentInfo["numberOfCustomers"]
    ) => {
        dispatch(
            createAction(ACTION_TYPES.EVENT.UPDATE_BOOKING_DATA, {
                numberOfCustomers,
            })
        );
    };

    return setNumberOfCustomers;
};
